<script lang="ts" module>
  // Реестр путей иконок (24x24, stroke-based, Lucide-подобный стиль).
  // Для кружка-номера используем две дуги окружности.
  export const ICONS = {
    cursor: 'M4 4l7.07 17 2.51-7.39L21 11.07z',
    arrow: 'M5 19L19 5M19 5h-7M19 5v7',
    square: 'M4 4h16v16H4z',
    lasso: 'M4 12c0-4 3-8 8-8s8 4 8 8-3 8-8 8-8-4-8-8z',
    pencil: 'M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
    text: 'M4 6V4h16v2M9 20h6M12 4v16',
    number: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z',
    blur: 'M4 4h16v16H4zM8 8h.01M12 12h.01M16 8h.01M8 16h.01M16 16h.01',
    undo: 'M3 7v6h6M3 13a9 9 0 1 0 3-7',
    redo: 'M21 7v6h-6M21 13a9 9 0 1 1-3-7',
    download: 'M12 3v12M7 10l5 5 5-5M5 21h14',
    trash: 'M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14',
    upload: 'M12 3v12M7 10l5-5 5 5M5 21h14',
    eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z',
    eyeOff: 'M2 2l20 20M9.9 4.2A10 10 0 0 1 12 4c6 0 10 7 10 7s-1 1.7-2.7 3.3M6.7 6.7C4.6 8.3 2 12 2 12s4 7 10 7c2 0 3.8-.6 5.3-1.5',
    lock: 'M5 11h14v10H5z M8 11V7a4 4 0 1 1 8 0v4',
    unlock: 'M5 11h14v10H5zM8 11V7a4 4 0 0 1 7-2.5',
    copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
    chevronUp: 'M6 15l6-6 6 6',
    chevronDown: 'M6 9l6 6 6-6',
    layers: 'M12 2l10 5-10 5L2 7l10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
    plus: 'M12 5v14M5 12h14',
    minus: 'M5 12h14',
    close: 'M6 6l12 12M18 6L6 18',
    check: 'M5 12l5 5L20 7',
    zoomIn: 'M11 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM21 21l-4.3-4.3M11 8v6M8 11h6',
    sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
    moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
  } as const;

  export type IconName = keyof typeof ICONS;
</script>

<script lang="ts">
  interface Props {
    name: IconName;
    size?: number;
    class?: string;
  }
  let { name, size = 20, class: cls = '' }: Props = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={cls}
  aria-hidden="true"
>
  <path d={ICONS[name]} />
</svg>
